import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { type ClaimFilters, createClaim, deleteClaim, getClaims, updateClaim } from '/@/store/claims/apiProviders';
import type { ClaimInput } from '/@/types/claim';
import { invalidate } from '/@/utils/swr';

const LIST_KEY = 'useClaims';

export const useClaims = (filters: ClaimFilters = {}) => {
    const key = filters.field && filters.dateGte && filters.dateLte ? { key: LIST_KEY, ...filters } : null;
    return useSWR(key, () => getClaims(filters), {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
};

export const useMutateCreateClaim = () =>
    useSWRMutation({ key: 'createClaim' }, (_key, { arg }: { arg: ClaimInput }) => createClaim(arg), {
        onSuccess: () => invalidate(LIST_KEY),
    });

export const useMutateUpdateClaim = () =>
    useSWRMutation(
        { key: 'updateClaim' },
        (_key, { arg }: { arg: { id: number } & ClaimInput }) => {
            const { id, ...data } = arg;
            return updateClaim(id, data);
        },
        { onSuccess: () => invalidate(LIST_KEY) }
    );

export const useMutateDeleteClaim = () =>
    useSWRMutation({ key: 'deleteClaim' }, (_key, { arg }: { arg: { id: number } }) => deleteClaim(arg.id), {
        onSuccess: () => invalidate(LIST_KEY),
    });
